import { DaDataResponse } from './types'

export const getCompanyData = async (prompt: string): Promise<DaDataResponse | null> => {
	try {
		const res = await fetch('/api/dadata/company', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ query: prompt }),
		})
		return (await res.json()) as DaDataResponse
	} catch {
		return null
	}
}
